import actions from './actions'
import mutations from './mutations'

const state = {
  ementaIdConcluida: null
}

const getters = {
  ementaIdConcluida: state => state.ementaIdConcluida
}

export default {
  state,
  getters,
  mutations,
  actions
}
